
import { ProjectComplet } from '@/interfaces/projects';
import { MutationTree } from 'vuex';
import { Project } from '../../interfaces/projects';



const mutation: MutationTree<ProjectComplet> = {
    setProject(state, project: Project) {
        state.project = project;
    },
    setProjectClient (state, client) {
        state.client = client;
    },
    setProjectDocuments(state, documents) {
        state.documents = documents;
    },
    setProjectSamples(state, samples: number) {
        state.samples = samples;
    },
    setProjectTotal(state, total: number) {
        state.total = total;
    },
    setProjectReview(state, review: number) {
        state.review = review;
    },
    setProjectReviewError(state, reviewError: number) {
        state.reviewError = reviewError;
    },
    setIsSearching(state, isSearching: boolean) {
        state.isSearching = isSearching;
    },
    setCurrentDate(state, currentDate: string) {
        state.currentDate = currentDate;
    },
    setNewDocsToday(state, newDocsToday: number) {
        state.newDocsToday = newDocsToday;
    },
    setPrioritario(state, prioritario: number) {
        state.prioritario = prioritario;
    },
    setReviewPending(state, reviewPending: number) {
        state.reviewPending = reviewPending;
    },
    setReviewedToday(state, reviewedToday: number) {
        state.reviewedToday = reviewedToday;
    },
}


export default mutation;